import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getAllReportProductMtSlice = createSlice({
    name: "getAllReportProductMt",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAllReportProductMtSlice_actions = getAllReportProductMtSlice.actions;
export var fetchData = _getAllReportProductMtSlice_actions.fetchData, fetchDataSuccess = _getAllReportProductMtSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllReportProductMtSlice_actions.fetchDataFailure, resetState = _getAllReportProductMtSlice_actions.resetState;
export default getAllReportProductMtSlice.reducer;
